declare namespace $ {

	type $shm_sort__sort_by_shm_wordstat_task_list_head_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list_head['sort_by'] >
		,
		ReturnType< $shm_sort['sort_by'] >
	>
	type $shm_sort__sort_order_shm_wordstat_task_list_head_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list_head['sort_order'] >
		,
		ReturnType< $shm_sort['sort_order'] >
	>
	type $shm_sort__options_shm_wordstat_task_list_head_3 = $mol_type_enforce<
		({ 
			'created': string,
			'updated': string,
		}) 
		,
		ReturnType< $shm_sort['options'] >
	>
	type $mol_pick__hint_shm_wordstat_task_list_head_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_wordstat_task_list_head_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_wordstat_task_list_head_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_link__uri_shm_wordstat_task_list_head_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list_head['title_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_wordstat_task_list_head_8 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list_head['title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_wordstat_task_list_head_9 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list_head['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_wordstat_task_list_head extends $shm_list_head {
		Menu_trigger_icon( ): $mol_icon_dots_vertical
		Task_sort( ): $shm_sort
		Sort_menu( ): $mol_pick
		controls( ): readonly(any)[]
		title_uri( ): string
		search_showed( ): boolean
		Title( ): $mol_link
		add_content( ): readonly(any)[]
		Controls( ): $mol_view
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map